<template lang="pug">
div
  .md-headline Publishing
  // Status
  status-radio(v-model='distribution.status')
  // Start date
  date-input(ref='availableFrom' v-show="distribution.status !== 'draft' ? true : false", v-model='distribution.startDate', :validation='validations.startDate', :formSubmitted='formSubmitted', label="Available from")
  // End date
  date-input(ref='availableUntil' v-show="distribution.status !== 'draft' ? true : false", v-model='distribution.endDate', :validation='validations.endDate', :formSubmitted='formSubmitted', label="Available until", v-bind:style= "dateValid ? null : { color: '#f44336' }")
  span.md-error(v-if="!dateValid && distribution.status !== 'draft'") The date of "available until" cannot be a day before today or before the date of "available from".
  rental-pricing-form(v-show="distribution.status !== 'draft' ? true : false", :price='(distribution.prices && distribution.prices.length > 0 && distribution.prices[0].price) ? distribution.prices[0].price.amount : null', @price-selected="handlePriceSelected")

</template>

<script>
  import StatusRadio from '../../StatusRadio';
  import DateInput from '../../forms/DateInput';
  import RentalPricingForm from '../../forms/RentalPricingForm.vue';

  export default {
    components: {
      DateInput,
      StatusRadio,
      RentalPricingForm
    },
    props: {
      distribution: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        required: true
      },
      validations: {
        type: Object,
        required: true
      },
      dateValid: {
        type: Boolean,
        required: true
      },
    },
    methods:{
      handlePriceSelected(option) {
            if(option) {
              this.$emit('price-selected', option)
            }
        }
    }
  };
</script>

<style lang="scss" scoped>
  .form-wrapper-frame {
    width: 100%;
    padding: 25px;
    margin-bottom: 15px;
    .md-headline {
      margin-bottom: 10px;
    }
  }
  .md-error{
    color: #f44336;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/PublishingForm.vue